import {LocatedNumbers} from "../../../common/utils/locatedNumbers";
import {resolve} from "../../../container";
import {LocalDate} from "../../../common/utils/dates/localDate";

export enum SortOrder {
    ASCENDING,
    DESCENDING
}

export interface SortByStrategy {
    sort: (a: string, b: string, order: SortOrder) => number;
    applicableFor: (text: string) => boolean;
}

export class SortByNumber implements SortByStrategy {

    private locatedNumbers: LocatedNumbers;

    public constructor(locatedNumbers: LocatedNumbers = resolve(LocatedNumbers)) {
        this.locatedNumbers = locatedNumbers;
    }

    public sort(a: string, b: string, order: SortOrder): number {
        const aNumber = this.locatedNumbers.parseFloat(a);
        const bNumber = this.locatedNumbers.parseFloat(b);
        if (aNumber === bNumber) {
            return 0;
        } else if (aNumber > bNumber && order === SortOrder.ASCENDING) {
            return 1;
        } else if (aNumber < bNumber && order === SortOrder.DESCENDING) {
            return 1;
        } else {
            return -1;
        }
    }

    public applicableFor(text: string): boolean {
        return /^[\d,.]+/.exec(text) !== null;
    }
}

export class SortByDate implements SortByStrategy {

    public sort(a: string, b: string, order: SortOrder): number {
        const aDate = LocalDate.fromDateExpression(a);
        const bDate = LocalDate.fromDateExpression(b);

        if (aDate && bDate) {
            if (aDate.isEqual(bDate)) {
                return 0;
            } else if (aDate.isAfter(bDate) && order === SortOrder.ASCENDING) {
                return 1;
            } else if (aDate.isBefore(bDate) && order === SortOrder.DESCENDING) {
                return 1;
            } else {
                return -1;
            }
        }
        return 0;
    }

    public applicableFor(text: string): boolean {
        return (/^\d{1,2}\.\d{1,2}\.\d{4}$/.exec(text) || /^\d{4}-\d{1,2}-\d{1,2}$/.exec(text)) !== null;
    }
}

export class SortByString implements SortByStrategy {

    public sort(a: string, b: string, order: SortOrder): number {
        if (a === b) {
            return 0;
        } else if (a > b && order === SortOrder.ASCENDING) {
            return 1;
        } else if (a < b && order === SortOrder.DESCENDING) {
            return 1;
        } else {
            return -1;
        }
    }

    public applicableFor(text: string): boolean {
        return true;
    }
}